// client/src/components/AuthCheck.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { retourVers } from '../utils/destination-connexion';

/**
 * Composant de vérification d'authentification
 * Utilisé pour protéger les routes qui nécessitent une authentification
 * Vérifie si l'utilisateur est connecté et a les droits nécessaires
 * Redirige vers la page de connexion si nécessaire
 */
const AuthCheck = ({ requiredRoles = [], children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  // Page à retrouver après connexion (le guichet, pas l'administration). Figée au montage dans
  // une ref : la vérification ne doit pas se relancer à chaque changement d'URL.
  const location = useLocation();
  const retour = useRef(retourVers(location));

  useEffect(() => {
    // Fonction pour vérifier le token
    const validateToken = async () => {
      const token = localStorage.getItem('token');
      
      // Si pas de token, rediriger vers la page de connexion
      if (!token) {
        setIsLoading(false);
        navigate('/login', { state: retour.current });
        return;
      }

      try {
        // Configurer les en-têtes avec le token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        // Vérifier la validité du token auprès du serveur
        const response = await axios.get('/api/auth/verify');
        
        if (response.data.success) {
          
        const user = response.data.data.user;

          // Vérifier les rôles si nécessaire
          if (requiredRoles.length > 0) {
          //  const user = response.data.data.user;
            if (!requiredRoles.includes(user.role)) {
              // L'utilisateur n'a pas le rôle requis
              navigate('/unauthorized');
              return;
            }
          }
           // Stocker l'utilisateur dans le localStorage pour les autres composants
           localStorage.setItem('user', JSON.stringify(user));

          // Mettre à jour l'état d'authentification
          setIsAuthenticated(true);
        } else {
          // Token invalide, rediriger vers la page de connexion
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          navigate('/login', { state: retour.current });
        }
      } catch (error) {
        // Erreur de vérification, rediriger vers la page de connexion
        console.error('Erreur lors de la vérification du token:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login', { state: retour.current });
      } finally {
        setIsLoading(false);
      }
    };

    validateToken();
  }, [navigate, requiredRoles]);

  // Afficher un écran de chargement pendant la vérification
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="p-8 bg-white rounded-lg shadow-md text-center">
          <div className="animate-spin h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-gray-700">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  // Si l'utilisateur est authentifié, afficher les enfants
  return isAuthenticated ? children : null;
};

export default AuthCheck;
